/* 当前页面监听到订单状态在其他页面发生更改，当前页面需要刷新 */
export function pageReloadInStatusChange() {
  window.addEventListener('storage', e => {
    if (localStorage.getItem('order_status_change') == 1) {
      localStorage.removeItem('order_status_change')
      location.reload()
    }
  })
}

/* 订单状态发生更改，通知其他页面 */
export function orderStatusChange() {
  localStorage.setItem('order_status_change', 1)
}
